import React from "react";

export const Loading = () => <div className="loading">Loading...</div>;
